import { FC } from "react";

interface RequiredFieldProps extends React.HTMLAttributes<HTMLSpanElement> {
  children?: React.ReactNode;
}

const RequiredField: FC<RequiredFieldProps> = ({ children, ...props }) => {
  return (
    <span className="required-field" {...props}>
      *
    </span>
  );
};

export default RequiredField;
